import { createQuery } from "@/queries";
import { fetchAuthUserInfo } from "@/features/auth/api/profile";
import type { AxiosResponse } from "axios";

type UserInfoResponse = Awaited<ReturnType<typeof fetchAuthUserInfo>> extends AxiosResponse<infer T>
  ? T
  : never;

export const useUserInfoQuery = () => {
  return createQuery<UserInfoResponse>({
    key: ["userInfo"],
    fetcher: async () => {
      const response = await fetchAuthUserInfo();
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

